export default "__VITE_ASSET__D5xqr2xB__"